import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import "../../../../styles/AppCss.css";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { getDetalleObsequio, postAddObsequio, postUpdateObsequio } from "../../../../api/ApiService";
import AddObsequiosComponents from "./components/AddObsequiosComponents";



function AddObsequiosPage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState("");
    const [descripcion, setDescripcion] = useState('');
    const [imagen, setImagen] = useState("");
    const [imagenFormData, setImagenFormData] = useState(null);
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [montoMinimo, setMontoMinimo] = useState("");
    const [montoGiftcard, setMontoGiftcard] = useState("");
    const [stockTotal, setStockTotal] = useState("");
    const [limitePorUsuario, setLimitePorUsuario] = useState("");
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [tipoObsequio, setTipoObsequio] = useState("");




    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!stateToken) {
            return;
        }

        if (id) {
            handleDetalleObsequioApi();
        } else {
            setCargando(true);
        }
    }, [id, stateToken]);




    //========================================================= funcion para cerrar la alerta
    const handleClose = () => {
        setOpen(false);
    };

    //========================================================= funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //========================================================= funcion para obtener el detalle de un obsequio
    const handleDetalleObsequioApi = () => {
        getDetalleObsequio(stateToken?.access_token, id)
            .then((response) => {
                console.log("response==>getDetalleObsequio", response);
                const detalle = response?.data || response || {};
                setTitulo(detalle?.titulo || "");
                setDescripcion(detalle?.descripcion || "");
                setImagen(detalle?.imagen_url || detalle?.imagen_url || detalle?.imagen_url || "");
                setImagenFormData(null);
                // fecha_fin: "2026-03-14T00:00:00.000000Z"
                // fecha_inicio: "2026-03-13T00:00:00.000000Z"
                // setFechaInicio(detalle?.fecha_inicio || "");
                // setFechaFin(detalle?.fecha_fin || "");
                setFechaInicio(detalle?.fecha_inicio ? detalle.fecha_inicio.split("T")[0] : "");
                setFechaFin(detalle?.fecha_fin ? detalle.fecha_fin.split("T")[0] : "");
                setTipoObsequio(detalle?.tipo || "");

                // setMontoMinimo(detalle?.monto_minimo?.toString() || "");
                //eliminar los ceros decimales si el monto es entero, sino mostrar con decimales
                const monto = detalle?.monto_minimo || "";
                const montoFormateado = Number(monto) % 1 === 0 ? Number(monto).toString() : Number(monto).toFixed(2);
                setMontoMinimo(montoFormateado);

                const montoGiftcardValor = detalle?.monto_giftcard || "";
                const montoGiftcardFormateado = Number(montoGiftcardValor) % 1 === 0 ? Number(montoGiftcardValor).toString() : Number(montoGiftcardValor).toFixed(2);
                setMontoGiftcard(montoGiftcardFormateado);

                setStockTotal(detalle?.stock_total?.toString() || "");
                setLimitePorUsuario(detalle?.limite_por_usuario?.toString() || "");
                setCargando(true);
            })
            .catch(() => {
                setCargando(true);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al cargar los datos del obsequio");
            });
    };

    //========================================================= funcion para validar campos obligatorios
    const validateFields = () => {
        if (titulo.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo titulo es obligatorio");
            return false;
        }
        if (descripcion.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo descripcion es obligatorio");
            return false;
        }
        if (imagen === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo image es obligatorio");
            return false;
        }
        if (fechaInicio === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo fecha_inicio es obligatorio");
            return false;
        }
        if (fechaFin === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo fecha_fin es obligatorio");
            return false;
        }
        if (tipoObsequio === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo tipo_obsequio es obligatorio");
            return false;
        }
        if (montoMinimo === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo monto_minimo es obligatorio");
            return false;
        }
        if (tipoObsequio === "giftcard" && montoGiftcard === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo monto gift card es obligatorio");
            return false;
        }
        if (stockTotal === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo stock_total es obligatorio");
            return false;
        }
        if (limitePorUsuario === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo limite_por_usuario es obligatorio");
            return false;
        }
        return true;
    };

    //========================================================= funcion para construir el formData del formulario
    const buildBody = () => {
        const formData = new FormData();
        formData.append("titulo", titulo);
        formData.append("descripcion", descripcion);
        formData.append("fecha_inicio", fechaInicio);
        formData.append("fecha_fin", fechaFin);
        formData.append("tipo", tipoObsequio);
        formData.append("monto_minimo", montoMinimo);
        formData.append("monto_giftcard", montoGiftcard);
        // if (tipoObsequio === "giftcard") {
        //     formData.append("monto_giftcard", montoGiftcard);
        // }
        formData.append("stock_total", stockTotal);
        formData.append("limite_por_usuario", limitePorUsuario);

        // Solo enviamos la imagen cuando hay un archivo seleccionado
        if (imagenFormData) {
            formData.append("imagen", imagenFormData);
        }

        return formData;
    };

    //========================================================= funcion para crear obsequio
    const handleAddObsequioApi = (body) => {
        postAddObsequio(stateToken?.access_token, body)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Guardado con exito");
                setTimeout(() => {
                    navigate('/app/admin/obsequios/listar');
                }, 1200);

                //limpiar campos
                setTitulo("");
                setDescripcion("");
                setImagen("");
                setImagenFormData(null);
                setFechaInicio("");
                setFechaFin("");
                setTipoObsequio("");
                setMontoMinimo("");
                setStockTotal("");
                setLimitePorUsuario("");
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al guardar el obsequio");
            });
    };

    //========================================================= funcion para actualizar obsequio
    const handleUpdateObsequioApi = (body) => {
        postUpdateObsequio(stateToken?.access_token, id, body)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Actualizado con exito");
                setTimeout(() => {
                    navigate('/app/admin/obsequios/listar');
                }, 1200);
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al actualizar el obsequio");
            });
    };

    //========================================================= funcion para guardar un nuevo obsequio
    const handleGuardar = () => {
        if (!validateFields()) {
            return;
        }

        setLoadingGuardar(true);
        handleAddObsequioApi(buildBody());
    };

    //========================================================= funcion para actualizar un obsequio existente
    const handleUpdate = () => {
        if (!validateFields()) {
            return;
        }

        setLoadingGuardar(true);
        handleUpdateObsequioApi(buildBody());
    };

    //========================================================= funcion para agregar/leer imagen y mostrar preview
    const handleAgregarImagen = (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            setImagen(e.target.result);
            setImagenFormData(file);
        };
        reader.readAsDataURL(file);
    };

    //========================================================= funcion para quitar imagen del formulario
    const handleQuitarImagen = () => {
        setImagen("");
        setImagenFormData(null);
    };


    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-6">
                        <h1 className="mb-1 text-2xl font-bold text-gray-800">
                            {id ? (mode === "view" ? "Detalle Obsequio" : "Actualizar Obsequio") : "Crear Obsequio"}
                        </h1>
                        <p className="text-sm text-gray-500">
                            {id ? (mode === "view" ? "Visualiza la informacion del obsequio." : "Actualiza la informacion principal del obsequio.") : "Carga la imagen y completa los datos principales del obsequio."}
                        </p>
                    </div>

                    {cargando ? (
                        <AddObsequiosComponents
                            id={id}
                            mode={mode}
                            titulo={titulo}
                            setTitulo={setTitulo}
                            descripcion={descripcion}
                            setDescripcion={setDescripcion}
                            imagen={imagen}
                            handleQuitarImagen={handleQuitarImagen}
                            fechaInicio={fechaInicio}
                            setFechaInicio={setFechaInicio}
                            fechaFin={fechaFin}
                            setFechaFin={setFechaFin}

                            montoMinimo={montoMinimo}
                            setMontoMinimo={setMontoMinimo}

                            montoGiftcard={montoGiftcard}
                            setMontoGiftcard={setMontoGiftcard}

                            stockTotal={stockTotal}
                            setStockTotal={setStockTotal}
                            limitePorUsuario={limitePorUsuario}
                            tipoObsequio={tipoObsequio}
                            setTipoObsequio={setTipoObsequio}
                            setLimitePorUsuario={setLimitePorUsuario}
                            handleAgregarImagen={handleAgregarImagen}
                            handleGuardar={handleGuardar}
                            handleUpdate={handleUpdate}
                            handleCancelar={handleCancelar}
                        />
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddObsequiosPage;